import styled from "@emotion/styled";

import { useFormatMessage } from "@skilitics/localization";

import { Tutorial } from "../../application";
import { ResponseByIdProvider } from "../ResponseByIdProvider";
import { ResponseEditorDndContext } from "./ResponseEditorDndContext";

const EmptyResponsePage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

type Props = {
  selectedResponseId: number;
};

export const ResponseEditorPage = ({ selectedResponseId }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);

  if (!selectedResponseId) {
    return (
      <EmptyResponsePage>
        <div>{formatMessage("emptyResponses")}</div>
      </EmptyResponsePage>
    );
  }

  return (
    <ResponseByIdProvider responseId={selectedResponseId}>
      <ResponseEditorDndContext responseId={selectedResponseId} />

      <Tutorial area="responses" />
    </ResponseByIdProvider>
  );
};

const formatStrings = {
  emptyResponses: {
    en: 'No response has been selected. Select a response in the sidebar, or click "Add New".',
  },
};
